var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge color-body",class:[
        ..._vm.cssClass,
        {
            [`badge--${_vm.type}`]: true,
            'badge--word-break': _vm.wordBreak,
            'badge--clickable': _vm.clickable,
            'badge--draggable': _vm.draggable,
            'badge--border': _vm.border,
            'max-w-full': _vm.truncate
        }
    ]},[_c('div',{staticClass:"d-inline-flex flex-v-center",class:{
            'max-w-full': _vm.truncate
        }},[_c('div',{class:{
                'whitespace-nowrap text-truncate': _vm.truncate
            }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }